export default "__VITE_ASSET__052150de__"